<div class="layout-topbar p-shadow-4">
    <div class="layout-topbar-left">
        <a class="layout-topbar-logo" routerLink="/">
            <img id="app-logo" src="assets/layout/images/logo-tovpil-2x.svg" alt="ultima-layout"
                style="height: 2.25rem">
        </a>

        <a class="layout-menu-button p-shadow-6" (click)="appMain.onMenuButtonClick($event)" pRipple>
            <i class="pi pi-chevron-right"></i>
        </a>

        <a class="layout-topbar-mobile-button" (click)="appMain.onTopbarMobileButtonClick($event)" pRipple>
            <i class="pi pi-ellipsis-v fs-large"></i>
        </a>
    </div>

    <div class="layout-topbar-right" [ngClass]="{'layout-topbar-mobile-active': appMain.mobileTopbarActive}">
        <div class="layout-topbar-actions-left">
            <p-megaMenu [model]="model" styleClass="layout-megamenu"></p-megaMenu>
        </div>
        <div class="layout-topbar-actions-right">
            <ul class="layout-topbar-items">

                <!-- PREFERENCIAS -->
                <li class="layout-topbar-item">
                    <a class="layout-topbar-action rounded-circle" (click)="appMain.onRightMenuButtonClick($event)"
                        pRipple>
                        <i class="pi fs-large"
                            [ngClass]="{'pi-arrow-left': !app.isRTL, 'pi-arrow-right': app.isRTL}"></i>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>